import React from "react";
import { Modal, Button } from "@veneer/core";

interface CourseApprovedModalProps {
  show: boolean;
  onClose: () => void;
  certificate: string;
  t: (key: string) => string;
  sanitizeUrl: (url: string) => string;
  decryptText: (text: string) => string;
}

export const CourseApprovedModal: React.FC<CourseApprovedModalProps> = ({
  show,
  onClose,
  certificate,
  t,
  sanitizeUrl,
  decryptText,
}) => {
  return (
    <div style={{ position: "relative" }}>
      <Modal
        className="modalCourseApproved"
        align="center"
        id="modalCourseApproved"
        show={show}
        onClose={onClose}
        footer={
          <Button onClick={onClose} appearance="primary">
            {t("header.closebutton")}
          </Button>
        }
        title={t("header.courseApproved")}
      >
        <div className="modalCourseApprovedDiv">
          {certificate && (
            <img
              className="modalCourseApprovedImage"
              src={`data:image/jpeg;base64, ${sanitizeUrl(decryptText(certificate))}`}
              alt={t("header.courseApproved")}
            />
          )}
        </div>
      </Modal>
    </div>
  );
};
